import { useNavigate } from "react-router-dom";
export default function TollCard({ toll, selected, onClick }) {
  const navigate = useNavigate();
  const clickHandler = () => {
    navigate(`/tolls/info?id=${toll.id}`);
  };
  return (
    <div
      onClick={onClick ? onClick : clickHandler}
      className={`grid items-center md:grid-cols-4 gap-x-6 ${selected ? "selected-card" : "card"}`}
    >
      <div className="flex items-center space-x-4">
        <p className="font-semibold text-stone-200">
          {toll.vehicle?.make} {toll.vehicle?.model} {toll.vehicle?.license}
        </p>
      </div>
      <div className="text-center">
        <p className="text-stone-200">{toll["Tolled At"]}</p>
      </div>
      <div className="text-center">
        <p className="text-stone-200">{toll["Reported At"]}</p>
      </div>
      <div className="text-center">
        <p className="text-stone-200">{toll.Amount}</p>
      </div>
    </div>
  );
}
